/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteBrandMutationResponse,
  DeleteBrandPathParams,
  DeleteBrand400,
  DeleteBrand404,
} from '../types/DeleteBrand'

function getDeleteBrandUrl({ id }: { id: DeleteBrandPathParams['id'] }) {
  const res = {
    method: 'DELETE',
    url: `/api/v1/products/catalog/brands/${id}/` as const,
  }
  return res
}

/**
 * @description Delete a brand.
 * @summary Delete a brand
 * {@link /api/v1/products/catalog/brands/:id/}
 */
export async function deleteBrand(
  { id }: { id: DeleteBrandPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteBrandMutationResponse,
    ResponseErrorConfig<DeleteBrand400 | DeleteBrand404>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteBrandUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
